export class UserDataValidation {

  static readonly EMAIL_MAX_LENGTH = 512;
  static readonly NAME_MAX_LENGTH = 512;

}
